export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[100dvh] flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20futuristic%20minimal%20background%20with%20subtle%20geometric%20glowing%20lines%20and%20particles%20monochrome%20dark%20grey%20black%20gradient%20smooth%20clean%20corporate%20tech%20atmosphere%20wide%20composition&width=1920&height=1080&seq=hero_bg_01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background" />
      </div>

      <div className="relative z-10 w-full px-6 md:px-12 lg:px-20 text-center">
        <div className="animate-fade-in">
          <p className="text-xs md:text-sm tracking-[0.3em] text-text-secondary mb-6 md:mb-8">
            PERFORMANCE-BASED DIGITAL MARKETING
          </p>
        </div>

        <h1 className="animate-fade-up text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold leading-tight tracking-tight text-white mb-6 md:mb-8 max-w-4xl mx-auto">
          広告成果に、経営視点で向き合う。
        </h1>

        <p className="animate-fade-up text-sm md:text-base lg:text-lg text-text-secondary leading-relaxed max-w-2xl mx-auto mb-10 md:mb-14">
          株式会社LoBは、広告運用・クリエイティブ・LPを一体で改善し、セールスとマーケティングを起点に、LTV向上や事業成長に貢献するWEB広告代理店です。
        </p>

        <div className="animate-fade-up flex flex-col sm:flex-row items-center justify-center gap-4 mb-12 md:mb-16">
          <a
            href="#services"
            onClick={(e) => {
              e.preventDefault();
              document
                .querySelector("#services")
                ?.scrollIntoView({ behavior: "smooth" });
            }}
            className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-accent text-white text-xs tracking-[0.2em] font-medium hover:bg-accent-light transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <span>事業内容を見る</span>
            <i className="ri-arrow-right-line" />
          </a>
          <a
            href="#company"
            onClick={(e) => {
              e.preventDefault();
              document
                .querySelector("#company")
                ?.scrollIntoView({ behavior: "smooth" });
            }}
            className="inline-flex items-center justify-center gap-2 px-8 py-3 border border-white/30 text-xs tracking-[0.2em] text-white hover:bg-white/10 hover:border-white/50 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <span>会社情報を見る</span>
          </a>
        </div>

        <div className="animate-fade-up flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-[11px] md:text-xs tracking-[0.15em] text-text-muted">
          <span className="flex items-center gap-2">
            <span className="w-1 h-1 rounded-full bg-accent" />
            WEB広告
          </span>
          <span className="flex items-center gap-2">
            <span className="w-1 h-1 rounded-full bg-accent" />
            数値に基づく運用
          </span>
          <span className="flex items-center gap-2">
            <span className="w-1 h-1 rounded-full bg-accent" />
            法令・媒体基準を遵守
          </span>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-px h-12 bg-gradient-to-b from-white/40 to-transparent" />
      </div>
    </section>
  );
}